import React, { useState, useEffect } from 'react'

export default function Checkbox({text, setActive, active}) {
    const [stateConf, setStateConf] = useState(active)

    useEffect(() => {
        setActive(stateConf)
    }, [stateConf])

    const toogleState = () => {
        setStateConf(!stateConf)
    }

    return (
        <div className="settings-checkbox">
            {stateConf ? <img src={require('../../assets/icons/checkbox_a.svg')} onClick={toogleState} alt="checked" /> : <img src={require('../../assets/icons/checkbox.svg')} onClick={toogleState} alt="unchecked" />}
            <p>{text}</p>
        </div>
    )
}
